<template>
  <div class="pe-form-body">
    <slot></slot>
  </div>
</template>

<style scoped>
.pe-form-body {
  display: flex;
  flex-direction: column;

  width: var(--pe-form-body-width, 100%);
  margin: var(--pe-form-body-mg, 0);

  padding: var(--pe-form-body-pd, 2.2vw);
  gap: var(--pe-form-body-gp, 4.1vh);

  background: var(--pe-form-body-bg, #fff);
  border-radius: var(--pe-form-body-b-rd, 0.5rem);

  box-shadow: var(--pe-form-body-shadow, 0 3.439px 3.439px 0 rgba(0, 0, 0, 0.20));
  backdrop-filter: var(--pe-form-body-backdrop, none);
}
</style>